import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-4 divide-y divide-gray-100 rounded-lg border border-gray-200" }
const _hoisted_2 = { class: "font-medium" }
const _hoisted_3 = { class: "text-gray-500" }
const _hoisted_4 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-400"
}
const _hoisted_5 = { class: "mt-4 flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm font-medium text-amber-800" }

import { ref, watch } from 'vue'


export default {
  __name: 'AutoChargeConfirmModal',
  props: {
  isOpen: Boolean,
  audiences: {
    type: Array,
    default: () => []
  }
},
  emits: ['confirm', 'cancel'],
  setup(__props) {

const props = __props



const acknowledged = ref(false)

// Reset the acknowledgement every time the modal opens.
watch(
  () => props.isOpen,
  isOpen => {
    if (isOpen) acknowledged.value = false
  }
)

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_TheModal = _resolveComponent("TheModal")

  return (_openBlock(), _createBlock(_component_TheModal, {
    "is-open": props.isOpen,
    "modal-title": "Confirm auto-charge",
    onCloseModal: _cache[3] || (_cache[3] = $event => (_ctx.$emit('cancel')))
  }, {
    main: _withCtx(() => [
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-sm text-gray-600" }, " Please confirm that you understand that by enabling auto-charge the customers in the following smartlists that were defined in this drop will be autocharged based on the rules you set in this drop. Additionally, smartlist members can change over time. ", -1)),
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.audiences, (row) => {
          return (_openBlock(), _createElementBlock("li", {
            key: row.name,
            class: "flex items-center justify-between px-3 py-2 text-sm text-gray-900"
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(row.name), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(row.count) + " Current members", 1)
          ]))
        }), 128)),
        (!props.audiences.length)
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, "No smart lists selected"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("label", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((acknowledged).value = $event)),
          type: "checkbox",
          class: "mt-0.5"
        }, null, 512), [
          [_vModelCheckbox, acknowledged.value]
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("span", null, " I understand the customers tied to the smart lists in this drop will be auto-charged and that smartlist members change over time. ", -1))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_NeueButton, {
        type: "secondary",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createTextVNode("Cancel", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_NeueButton, {
        type: acknowledged.value ? 'primary' : 'inactive',
        disabled: !acknowledged.value,
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('confirm')))
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createTextVNode(" Confirm ", -1)
        ]))]),
        _: 1
      }, 8, ["type", "disabled"])
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

}